module.exports = __webpack_public_path__ + "static/media/UZ.78717724.png";